<template>
  <el-dialog
    :visible="dialogShow"
    :before-close="beforeClose"
    :title="title"
    width="750px"
  >
    <div class="form-content">
      <oss-form
        ref="outform"
        @submit="submit"
      ></oss-form>
    </div>
    <div slot="footer" class="footer">
      <el-button
        type="text"
        style="margin-right: 30px;"
        @click="cancel"
      >取消
      </el-button>
      <vs-button
        type="filled"
        color="primary"
        @click="confirm"
      >确认
      </vs-button>
    </div>
  </el-dialog>
</template>

<script>
import ossForm from "@/components/oss/ossForm";
import {addOss} from "@/api/oss/oss";

export default {
  name: "ossConfigDialog",
  components: {
    ossForm,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      title: '云存储配置',
    }
  },
  watch:{
  },
  methods: {
    beforeClose() {
      this.$emit('close');
      this.$refs.outform.selfClear();
    },
    cancel() {
      this.beforeClose();
    },
    confirm() {
      this.$refs.outform.selfValidate();
    },
    submit(form) {
      let params = {
        ...form,
      }
      addOss(params).then((data) => {

        if(data&&data.code&&data.code == 200){
          this.$message({
            message: '添加成功',
            type: 'success',
          });
          this.$refs.outform.selfClear();
          this.$emit('add-success');
        }else{
          this.$message.error(data.msg);
        }
      })
    }
  },
}
</script>

<style scoped>

</style>
